import { Intervention } from '@/app/components/action-plan/types';
import { getCancerRiskSuffix, getInterventionHighestRisk } from '@/utils';
import { useDisclosure } from '@cmpsr/components';

export default function useInterventionCardController(intervention: Intervention) {
  const { id, title, riskImpact, isNonQuantifiable } = intervention;
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { reducedRisk, otherCancers } = getInterventionHighestRisk(riskImpact);

  const cancerRiskSuffix = getCancerRiskSuffix(reducedRisk?.cancerType);

  return {
    id,
    title,
    riskImpact,
    isNonQuantifiable,
    isOpen,
    onOpen,
    onClose,
    reducedRisk,
    cancerRiskSuffix,
    otherCancers,
  };
}
